cafm.browsers.bbMobile = {

	fixKendoDropdown: function (args) {

		bbMobile.fixKendoListContainer(args);
	},
	fixKendoComboBox: function (args) {

		bbMobile.fixKendoListContainer(args);
	},
	fixKendoListContainer: function (args) {

		var widget = args.widget;
		var element = widget.element;
		var relevance = isFunc(args.relevance) ? args.relevance : null;

		widget.bind('open', function (args) {

			if (!relevance || relevance(args)) {

				element.data('preventClose', true);

				$('body').on('touchstart.cafm', function (ev) {

					if (!$(ev.target).parents('.k-animation-container:first').length) {

						element.removeData('preventClose');
						widget.close();
					}
				});
			}
		});

		widget.bind('change', function (args) {

			element.removeData('preventClose');
			widget.close();
		});

		widget.bind('close', function (args) {

			if (!relevance || relevance(args)) {

				if (element.data('preventClose')) {

					args.preventDefault();
				}
				else {

					$('body').off('touchstart.cafm');
					element.removeData('preventClose');
				}
			}
		});
	}
}
var bbMobile = cafm.browsers.bbMobile;